
<div class="row" *ngIf="guardian">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info text-center">Subscription Groupings for {{guardian.fullname}}</h3>
  </div>

</div>
<div class="table-responsive" *ngIf="subscriptionGroupingList">

<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
    <th></th>
    <th>Name</th>
    <th>Description</th>
    <th>students</th>
    <th>Group</th>
    <th>Edit</th>
    <th>Delete</th>
  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let subscriptionGrouping of subscriptionGroupingList;">

    <td>
        <a [routerLink]="['/batch/grouping/show',subscriptionGrouping.server_subscription_grouping_id]">{{subscriptionGrouping.server_subscription_grouping_id}}</a>
    </td>
    <td>{{subscriptionGrouping.name}}</td>
    <td>{{subscriptionGrouping.description}}</td>
    <td>{{subscriptionGrouping.studentCount}}</td>
    <td>{{subscriptionGrouping.subscriptionGroup.name}}</td>
    <td>
      <a [routerLink]="['/batch/group/edit',subscriptionGrouping.server_subscription_grouping_id]">
        <i class="fa fa-edit"></i>
      </a>
    </td>
    <td>
      <button (click)="deleteGrouping(subscriptionGrouping.server_subscription_grouping_id)">
        <i class="fa fa-trash"></i>
      </button>
    </td>
  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="subscriptionGroupingList && loading"></app-spinner>
<div *ngIf="!subscriptionGroupingList && !loading" class="text-center">No Records Found </div>




